(ns frontend.view.modals.curtains.exit-opportunity.events
  (:require [common.localization :as loc]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.confirmation.view :as confirmation-modal]
            [frontend.logging :as logging]
            [frontend.actions.exit-opportunity :as exit-opportunity-actions]))

(defn confirm-loss [state exit-opportunity close-modal!]
  (let [edits (:edit @state)
        confirm-text (loc/tr :exit-opportunity-loss-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body         [:div.text-center
                     [:p confirm-text]]
      :confirm-text (loc/tr :confirm)
      :confirm-icon ""
      :skip-checkbox? true
      :on-confirm   (fn [_]
                      (exit-opportunity-actions/*->lost!
                       {:exit-opportunity-id (:db/id exit-opportunity)
                        :loss-reason-id      (:exit-opportunity/lost-reason (:edit @state))
                        :loss-comment        (:internal-comment (:edit @state))}
                       (fn [_]
                         (close-modal!))
                       (fn [err]
                         (logging/error "Failed to set exit opportunity status to lost" err))))})))

(defn confirm-on-hold [state exit-opportunity close-modal!]
  (let [edits (:edit @state)
        {:keys [months until internal-comment]} edits
        until (if (zero? months)
                until
                months)
        confirm-text (loc/tr :exit-opportunity-on-hold-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body          [:div.text-center
                      [:p confirm-text]]
      :confirm-text  (loc/tr :confirm)
      :confirm-icon  ""
      :skip-checkbox? true
      :title         (loc/tr :submit)
      :on-confirm    (fn [_]
                       (exit-opportunity-actions/*->put-on-hold
                        {:exit-opportunity-id (:db/id exit-opportunity)
                         :on-hold-until       until
                         :on-hold-comment     (:internal-comment (:edit @state))}
                        (fn [_]
                          (close-modal!))
                        (fn [err]
                          (logging/error "Failed to set exit opportunity status to on hold" err))))})))
